import React from 'react';
import { Sparkles } from 'lucide-react';
import { Ticket } from '../lib/types';
import { DraftIdle } from './draft/DraftIdle';
import { DraftEditor } from './draft/DraftEditor';
import { DraftActionProps } from './draft/DraftActions';

type Props = Omit<DraftActionProps, 'ticket'> & {ticket: Ticket | null;
  setDraft: (draft: string) => void; busy: boolean; stage: string};

export const DraftPanel = ({ticket, busy, stage, ...editor}: Props) => <section className="draft-column">
  <div className="column-heading"><div><span className="step-number accent">02</span><h2 data-testid="draft-heading">Your reply, a head start</h2></div><span className="ai-tag" data-testid="ai-assistant-badge"><Sparkles size={12}/>AI ASSISTED</span></div>
  {!ticket || busy ? <DraftIdle busy={busy} stage={stage}/> : <DraftEditor ticket={ticket} {...editor}/>}
</section>;